<template>
  <TTabsToggle
    :header="$t('forms.settings_element_text')"
    no-move
    :changed="padding.changed"
    data-testid="text-settings"
  >
    <padding-form
      external-usage
      :external-padding="padding.model"
      :changed="padding.changed"
      :default-value="padding.defaultValue"
      data-testid="settings-text-padding"
      @padding-changed="padding.model = $event"
      @reset="padding.reset"
    />
  </TTabsToggle>
</template>

<script setup lang="ts">
  import paddingForm from "@/forms/paddingForm.vue";
  import { useBlockAttr } from "@/composables/useBlockAttr";
  import { TTabsToggle } from "@topol/twig-ui";

  const { nullable } = useBlockAttr({
    mode: "global",
    block: "mj-text",
  });

  const padding = nullable("padding");
</script>
